import { HttpResult } from 'widgets-for-react'

type PhoneNumbersApiResponse = {
  PhoneNumber: string
}[]

export const phoneNumbersBlockApi = async (ids: number[]): Promise<HttpResult<string[]>> => {
  const res = await fetch(`/api/v1/phoneNumbers?${ids.map((id) => `ids=${id}`).join('&')}`)

  if (!res.ok)
    return {
      kind: 'failed',
      status: res.status,
    }

  const data: PhoneNumbersApiResponse = await res.json()

  return {
    kind: 'result',
    status: 200,
    value: data.map((item) => item.PhoneNumber),
  }
}
